import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { CapabilityEngineService } from '../capabilityEngine.service';

@Injectable()
export class TeamDetailsService {

    constructor(
        private http: HttpClient,
        private _capEngineService: CapabilityEngineService
    ) { }

    getTeamDetails(teamId) {
        let header = this._capEngineService.getHeaders('viewTeamDetails');
        return this.http.get(environment.serverUrl + '/team/' + teamId, header);
    }

    deactivateTeam(teamId) {
        let header = this._capEngineService.getHeaders('deactivateTeam');
        return this.http.get(environment.serverUrl + '/team/deactivate' + teamId);
    }

    updateUserStatus(teamId, userId, payload) {
        let url = `${environment.serverUrl}/team/${teamId}/user/${userId}/status`;
        return this.http.put(url, payload);
    }

    updateUserRole(teamId, userId, payload) {
        let url = `${environment.serverUrl}/team/${teamId}/user/${userId}/role`;
        return this.http.put(url, payload);
    }
}



// WEBPACK FOOTER //
// ./src/app/team-details/team-details.service.ts